import * as loaders from "loaders/legacy/legacy-glTFFileLoader";
export { loaders };
export default loaders;
